import { ThemeProvider as NextThemesProvider } from 'next-themes';

type ThemeProviderProps = Readonly<React.ComponentProps<typeof NextThemesProvider>>;

const DIQ_THEMES = ['light', 'dark', 'ace', 'mia'];

export const ThemeProvider = ({ children, ...props }: ThemeProviderProps): JSX.Element => (
  <NextThemesProvider attribute="data-theme" themes={DIQ_THEMES} {...props}>
    {children}
  </NextThemesProvider>
);
